module.exports = __webpack_public_path__ + "static/media/sign-in-with-google.ea4c13b2.svg";